import React from 'react';

export default function WizardSidebar({ steps, fields, currentStep, values, filesState, onStepClick, stepIsComplete }) {
  return (
    <nav className="wizard-sidebar" aria-label="Form steps">
      {(steps || []).map((step, index) => {
        const complete = stepIsComplete(step, fields, values, filesState);
        return (
          <button
            key={step.id}
            type="button"
            className={`wizard-sidebar-item${index === currentStep ? ' active' : ''}${complete ? ' complete' : ''}`}
            onClick={() => onStepClick(index)}
          >
            <span className="wizard-step-icon">{complete ? '✓' : index + 1}</span>
            <span>{step.title}</span>
          </button>
        );
      })}
    </nav>
  );
}
